<template>
  <div class="modal-overflow">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Name</label>
          <el-input type="text"
                    name="planName"
                    placeholder="Plan Name"
                    clearable
                    :disabled="!canEdit"
                    v-validate="'validNameOrNumber'"
                    v-model="edit.name"/>
          <small class="text-danger" v-show="errors.has('planName')">
            {{ this.nameOrNumberErrorMessage }}
          </small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <div class="form-group">
          <label>Number</label>
          <el-input type="text"
                    name="planNumber"
                    placeholder="Plan Number"
                    clearable
                    :disabled="!canEdit"
                    v-validate="'validNameOrNumber'"
                    v-model="edit.number"/>
          <small class="text-danger" v-show="errors.has('planNumber')">
            {{ this.nameOrNumberErrorMessage }}
          </small>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Hand</label>
          <el-select class="select"
                     name='hand'
                     size="large"
                     :disabled="!canEdit"
                     placeholder="Hand"
                     v-model="edit.hand">
            <el-option v-for="hand in hands"
                       class="select"
                       :value="hand"
                       :label="hand"
                       :key="hand">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Builder</label>
          <div style="margin-top:10px;">
            <el-autocomplete
              style="width:100%"
              name="builderId"
              class="inline-input"
              :debounce="150"
              ref="builderId"
              clearable
              :disabled="!canEdit"
              v-model="localBuilder"
              data-vv-as="builder"
              data-vv-validate-on="blur"
              v-validate="modelValidations.builderId"
              :fetch-suggestions="findBuilders"
              :trigger-on-focus="false"
              value-key="name"
              placeholder="Builder"
              @blur="verifyBuilderAutocompleteSelected"
              @select="addBuilder">
            </el-autocomplete>
            <small class="text-danger" v-show="errors.has('builderId')">
              {{ getError('builderId') }}
            </small>
            <small class="text-danger" v-show="showInvalidAutocompleteWarning('builderId')">
              {{ fieldNotValidError('Builder') }}
            </small>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="form-group">
          <label>Form</label>
          <el-autocomplete
            style="width:100%; margin-bottom: 12px;"
            name="formToAdd"
            class="inline-input"
            clearable
            :debounce="150"
            :disabled="!canEdit"
            v-model="formToAdd"
            :fetch-suggestions="findForms"
            :trigger-on-focus="false"
            value="id"
            value-key="name"
            placeholder="Type Form Name to Search"
            @select="setForm">
          </el-autocomplete>
        </div>
      </div>
      <div class="col-md-4" style="padding-top: 20px;">
        <button type="button" v-if="canEdit" @click="uploadFloorPlan" style="margin-left: -5px;" class="btn btn-fill btn-info">
          Upload New
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <el-table class="table-striped"
                  :data="localForms"
                  row-key="label"
                  border
                  style="width: 100%">
          <el-table-column label="Form">
            <template v-slot="props">
              {{ props.row.name }}
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            fixed="right"
            label="Actions">
            <template v-slot="props">
              <div style="text-align:center">
                <p-button type="danger" size="sm" v-if="canEdit" icon @click="handleDeleteForm">
                  <i class="fa fa-times"></i>
                </p-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="row" style="margin-top: 12px;">
      <div class="col-md-8">
        <div class="form-group">
          <label>Energy Form</label>
          <el-autocomplete
            style="width:100%; margin-bottom: 12px;"
            name="formToAdd"
            class="inline-input"
            clearable
            :debounce="150"
            :disabled="!canEdit"
            v-model="energyPlanToAdd"
            :fetch-suggestions="findEnergyPlans"
            :trigger-on-focus="false"
            value="id"
            value-key="name"
            placeholder="Type Energy Form Name to Search"
            @select="setEnergyPlan">
          </el-autocomplete>
        </div>
      </div>
      <div class="col-md-4" style="padding-top: 20px;">
        <button type="button" v-if="canEdit" @click="uploadEnergyPlan" style="margin-left: -5px;" class="btn btn-fill btn-info">
          Upload New
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <el-table class="table-striped"
                  :data="localEnergyPlans"
                  row-key="label"
                  border
                  style="width: 100%">
          <el-table-column label="Form">
            <template v-slot="props">
              {{ props.row.name }}
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            fixed="right"
            label="Actions">
            <template v-slot="props">
              <div style="text-align:center">
                <p-button type="danger" size="sm" v-if="canEdit" icon @click="handleDeleteEnergyPlan">
                  <i class="fa fa-times"></i>
                </p-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="row" style="margin-top: 15px" v-if="canEdit">
      <div class="col-md-12">
        <button type="button" :disabled="isSubmitDisabled" @click="validateAndSubmit" class="btn btn-fill btn-info btn-wd pull-right">Save</button>
        <div class="form-group form-group-active-label">
          <label class="active-label">Active</label>
          <p-switch v-model="edit.active" type="primary" on-text="YES" off-text="NO"></p-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {
    notifySuccess,
    notifyError,
    objectById,
    verifyAutocompleteSelected,
    autocompleteReady,
    autocompleteTextButNoValue,
    autocompleteTextButNoValueMessage
  } from 'src/utilities/utils'
  import Constants from 'src/utilities/constants'
  import Permissions from 'src/utilities/permissions'
  import PButton from 'src/components/UIComponents/Button.vue'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import {planNameOrNumber} from 'src/utilities/validation'
  import {sync} from 'vuex-pathify'
  import {OK} from 'http-status-codes'

  export default {
    props: ['data'],
    components: {
      PButton,
      PSwitch
    },
    computed: {
      edit: sync('planNames@edit'),
      ...mapGetters({
        builders: 'companies/results',
        autocompleteBuilders: 'companies/autocompleteResultsBuilder',
        putPayload: 'planNames/putPayload',
        postPayload: 'planNames/postPayload'
      }),
      canEdit() {
        return this.$can('edit', Permissions.PLAN_NAMES)
      },
      isSubmitDisabled() {
        return this.isProcessing
      }
    },
    data() {
      return {
        constants: Constants,
        formToAdd: null,
        energyPlanToAdd: null,
        isProcessing: false,
        localBuilder: null,
        localForms: [],
        localEnergyPlans: [],
        hands: ['Left', 'Right'],
        newBuilder: false,
        planNameSaved: false,
        modelValidations: {
          builderId: {
            required: true
          }
        },
        nameOrNumberErrorMessage: 'Enter a plan name, a plan number or both.'
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      showInvalidAutocompleteWarning(refAndPathName) {
        // $ref has to match prop in store
        return autocompleteTextButNoValue(this, refAndPathName, this.$store.get(`planNames/edit@${refAndPathName}`))
      },
      fieldNotValidError(field) {
        return autocompleteTextButNoValueMessage(field)
      },
      async findForms(text, cb) {
        if (autocompleteReady(text)) {
          await this.$store.dispatch('files/fileNameContains', {
            folder: Constants.FOLDERS.FLOOR_PLANS,
            name: text
          })
          cb(this.$store.getters['files/autocompleteResults'])
        }
      },
      async findEnergyPlans(text, cb) {
        if (autocompleteReady(text)) {
          await this.$store.dispatch('files/fileNameContains', {
            folder: Constants.FOLDERS.ENERGY_PLANS,
            name: text
          })
          cb(this.$store.getters['files/autocompleteResults'])
        }
      },
      setForm(file) {
        if (file) {
          this.$store.set('planNames/edit@fileId', file.id)
          this.localForms = [] // only allow one form
          this.localForms.push(file)
        }
        this.formToAdd = ''
      },
      setEnergyPlan(file) {
        if (file) {
          this.$store.set('planNames/edit@energyPlanId', file.id)
          this.localEnergyPlans = [] // only allow one form
          this.localEnergyPlans.push(file)
        }
        this.formToAdd = ''
      },
      handleDeleteForm() {
        this.$store.set('planNames/edit@fileId', null)
        this.localForms = []
      },
      handleDeleteEnergyPlan() {
        this.$store.set('planNames/edit@energyPlanId', null)
        this.localEnergyPlans = []
      },
      async validateAndSubmit() {
        this.isProcessing = true

        if (await this.$validator.validateAll()) {
          const savePayload = this.$store.get('planNames/savePayload', 'plan-names')
          const response = await this.$store.dispatch('save', savePayload)
          if (response.result === Constants.RETURN_CODES.SUCCESS) {
            this.$store.commit('planNames/resetEdit')
            if (this.data && this.data.id) {
              response.data.builderName = this.localBuilder
              this.$store.commit('planNames/updateResult', response.data)
            }
            this.planNameSaved = true
            this.$eventHub.$emit('planNameSaved', response.data)
            this.$emit('close')
            notifySuccess(this, 'Plan Name Saved Successfully')
          } else if (response.result === Constants.RETURN_CODES.ERROR) {
            notifyError(this, 'Error Saving Plan Name', response.errors)
          }
        }
        this.isProcessing = false
      },
      addBuilder(builder) {
        this.$store.set('planNames/edit@builderId', builder.id)
        this.$store.commit('companies/autocompleteResultsBuilder', [])
        this.newBuilder = false
      },
      verifyBuilderAutocompleteSelected() {
        if (this.newBuilder) {
          return
        }
        verifyAutocompleteSelected(this, 'planNames/edit@builderId', 'builder', this.localBuilder)
      },
      findBuilders(text, cb) {
        this.$store.set('planNames/edit@builderId', null)
        this.findCompany(text, Constants.COMPANY.TYPES.BUILDER)
        if (Array.isArray(this.autocompleteBuilders)) {
          cb(this.autocompleteBuilders)
        }
      },
      async findCompany(text, type) {
        if (autocompleteReady(text)) {
          const payload = {
            type: type,
            name: text
          }
          const response = await this.$store.dispatch('companies/fetchByNameStartsWithAndType', payload)
          if (OK === response.status && response.data.length === 0) {
            this.newBuilder = true
            this.$refs.builderId.$refs.suggestions.showPopper = false
            this.$eventHub.$emit('show-modal-4', 'No Company Results Found', payload, '500px')
          }
        }
      },
      clearBuilder() {
        this.localBuilder = null
        this.newBuilder = false
      },
      getBuilderName(builderId) {
        const builder = objectById(this.builders, builderId)
        if (builder) {
          return builder.name
        }
        return builderId
      },
      async setBuilderNameFromId(builderId) {
        const response = await this.$store.dispatch('fetchById', {
          endpoint: Constants.ENTITY_ENDPOINTS.COMPANIES,
          id: builderId
        })

        if (OK === response.status) {
          this.localBuilder = response.data.name
        }
      },
      async getHydrateForm(fileId) {
        const response = await this.$store.dispatch('fetchById', {
          endpoint: 'files',
          id: fileId
        })
        if (OK === response.status) {
          return this.localForms = [response.data]
        }
      },
      async getHydrateEnergyPlan(fileId) {
        const response = await this.$store.dispatch('fetchById', {
          endpoint: 'files',
          id: fileId
        })
        if (OK === response.status) {
          return this.localEnergyPlans = [response.data]
        }
      },
      async uploadFloorPlan() {
        this.$eventHub.$emit('show-modal-5', 'Upload Forms', {folder: Constants.FOLDERS.FLOOR_PLANS}, '500px')
      },
      async uploadEnergyPlan() {
        this.$eventHub.$emit('show-modal-5', 'Upload Forms', {folder: Constants.FOLDERS.ENERGY_PLANS}, '500px')
      },
      appendUploadedFile(files) {
        if (Array.isArray(files)) {
          this.setForm(files[0])
        }
      }
    },
    beforeCreate() {
      planNameOrNumber(this.$store)
    },
    async beforeMount() {
      this.$store.commit('planNames/resetEdit')

      if (this.data) {
        if (this.data.id) {
          const response = await this.$store.dispatch('fetchById', {
            endpoint: 'plan-names',
            id: this.data.id
          })

          if (OK === response.status) {
            this.$store.commit('planNames/hydrateEdit', response.data)

            const planName = response.data

            if (planName.fileId) {
              await this.getHydrateForm(response.data.fileId)
            }

            if (planName.energyPlanId) {
              await this.getHydrateEnergyPlan(response.data.energyPlanId)
            }

            if (response.data.name) {
              this.$store.set('planNames/edit@name', planName.name)
            }

            if (planName.builderId) {
              await this.setBuilderNameFromId(planName.builderId)
              this.$store.set('planNames/edit@builderId', planName.builderId)
            }
            return
          }
        }
      // Creating Plan Name on the fly.
        if (this.data.builderId) {
          await this.setBuilderNameFromId(this.data.builderId)
          this.$store.set('planNames/edit@builderId', this.data.builderId)
        }
        if (this.data.name) {
          this.$store.set('planNames/edit@name', this.data.name)
        }
      }
    },
    mounted() {
      this.$eventHub.$on('floorPlanUploaded', this.appendUploadedFile)
      this.$eventHub.$on('companySaved', this.addBuilder)
      this.$eventHub.$on('noCompanySelected', this.clearBuilder)
      this.$validator.reset()
    },
    destroyed() {
      this.$eventHub.$off('floorPlanUploaded')
      this.$eventHub.$off('companySaved')
      this.$eventHub.$off('noCompanySelected')
      if (!this.planNameSaved) {
        this.$eventHub.$emit('noPlanNameSelected')
      }
    },
    watch: {
      localBuilder: {
        handler: function (localBuilder) {
          if (!localBuilder) {
            this.$store.set('planNames/edit@builderId', null)
          }
        }
      }
    }
  }
</script>

<style scoped>
  label {
    display: block;
  }
</style>
